import { useEffect, useState } from 'react';
import type { ChefeEstado } from '../api/evento';
import { numero, t } from '../i18n/idioma';
import { nomeDoMapa } from '../i18n/nomes';
import { corDaMatiz } from '../look/traje';
import { Selo } from './eventos/Selo';
import { chefeVivo } from './eventos/tipos';

interface Props {
  estado: ChefeEstado | null;
  onClick(): void;
}

/**
 * A barra do Chefe do Mundo no canto (techspec-chefe-mundo §07): a vida do shard inteiro, o relógio até ele fugir e
 * quantos estão lutando, na cor do Balron que apareceu. Clicar abre Mais › Eventos.
 */
export function ChefeBarra({ estado, onClick }: Props) {
  const [, setTick] = useState(0);
  const vivo = chefeVivo(estado);
  useEffect(() => {
    if (!vivo) return;
    const id = window.setInterval(() => setTick(n => n + 1), 1000);
    return () => window.clearInterval(id);
  }, [vivo]);
  if (!estado || !vivo) return null;
  const pct = Math.max(0, Math.min(100, estado.permil / 10));
  const s = Math.max(0, Math.floor((estado.fimEmMs - Date.now()) / 1000));
  const cor = corDaMatiz(estado.matiz);
  return (
    <button type="button" className="chefe-barra" onClick={onClick} style={{ '--chefe': cor } as React.CSSProperties}
      aria-label={t('chefe.barra.aria', { nome: estado.nome, p: Math.ceil(pct) })}>
      <span className="chefe-barra__selo"><Selo id="chefe" /></span>
      <span className="chefe-barra__corpo">
        <span className="chefe-barra__nome">{estado.nome}<small>{nomeDoMapa(estado.mapa)}</small></span>
        <span className="chefe-barra__vida" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.ceil(pct)}>
          <i style={{ width: `${pct}%` }} />
          <b>{pct.toLocaleString(undefined, { maximumFractionDigits: 1 })}%</b>
        </span>
        <span className="chefe-barra__pe">
          <span>{t('chefe.barra.lutando', { n: numero(estado.lutadores) })}</span>
          <span className="chefe-barra__t">{mmss(s)}</span>
        </span>
      </span>
    </button>
  );
}

function mmss(s: number): string {
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}
